// ─── API layer for Email Template customisation ──────────────────────────────
// All endpoint knowledge for this feature lives here; components call these
// named functions and never assemble URLs. apiCall injects auth and returns
// { isSuccess, data, message }.
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";

const TEMPLATES = `${config.POSTLOGIN_API_URL_COMPANY}reminders/templates`;

/**
 * Lists the templates whose wording and branding can be customised.
 * @returns {Promise<object>} apiCall result whose data is the template array.
 */
export const listTemplates = () => apiCall(`${TEMPLATES}`, {}, {}, "GET");

/**
 * Fetches a template's slot values, resolved against the shipped defaults.
 * @param {string} templateKey the template.
 * @returns {Promise<object>} apiCall result whose data is the resolved slots.
 */
export const getCustomisation = (templateKey) =>
  apiCall(`${TEMPLATES}/customisation/${templateKey}`, {}, {}, "GET");

/**
 * Stores a template's slot values.
 * @param {object} payload the slots to store, including `templateKey`.
 * @returns {Promise<object>} apiCall result whose data is the resolved slots.
 */
export const saveCustomisation = (payload) =>
  apiCall(`${TEMPLATES}/customisation`, {}, payload, "PUT");

/**
 * Reverts a template to the values it ships with.
 * @param {string} templateKey the template.
 * @returns {Promise<object>} apiCall result whose data is the default slots.
 */
export const resetCustomisation = (templateKey) =>
  apiCall(`${TEMPLATES}/customisation/${templateKey}`, {}, {}, "DELETE");
